import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '../../../app/core/services/seo.service';
import { CommonService } from '../../../app/core/services/common.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

declare var $:any;

@Component({
  selector: 'app-real-estate',
  templateUrl: './real-estate.component.html',
  styleUrls: ['./real-estate.component.scss'],
  providers: [MessageService]
})
export class RealEstateComponent implements OnInit {

  constructor(private router : Router,private seo :SeoService, private translate : TranslateService,private titleService : Title,
   private renderer: Renderer2,
     @Inject(PLATFORM_ID) private platformId: Object, private sanitizer: DomSanitizer, private formBuilder: FormBuilder,
     public commonService : CommonService, private el: ElementRef,private cdr: ChangeDetectorRef,private messageService: MessageService) { }
    signUrl = environment.WEB_URL;
   emailValidations: FormGroup;
    plansLoader = false;
    subscriptionPlans = [];
    selectedPlanView = 0;
    domainError = false;

  ngOnInit(): void {
    this.getPlansDetails();
      this.emailValidations = this.formBuilder.group({
        emailId: [
          "",
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
            ),
          ],
        ],
      });
    }
  
    get f(): { [key: string]: AbstractControl } {
      return this.emailValidations.controls;
    }
  
    validateEmailDomain(email) {
      this.commonService.validateEmailDomains(email).subscribe((res: any) => {
        if (res) {
        } else {
          this.showError("Enter valid email address");
        }
      });
    }
  
    showError(message) {}
  
  
    onSubmit() {
      // Mark all controls as touched to trigger validation errors
      this.markFormGroupTouched(this.emailValidations);
      if (this.emailValidations.valid) {
        this.commonService.validateEmailDomains($('#workmail').val()).subscribe((res: any) => {
          this.domainError = false;
          if (res) {
            const newTab = this.renderer.createElement('a');
            this.renderer.setAttribute(newTab, 'href', this.signUrl + 'get-started/u/setup-profile?workmail=' + $('#workmail').val());
            this.renderer.setAttribute(newTab, 'target', '_blank');
            this.renderer.appendChild(document.body, newTab);
            newTab.click();
            this.renderer.removeChild(document.body, newTab);
          } else {
            this.domainError = true;
            this.messageService.add({
              severity: 'error',
              detail: 'Enter a valid workmail.',
            });
            return;
          }  
        });
      } else {
        if (this.emailValidations.invalid) {
          if (this.emailValidations.get('emailId')?.hasError('required')) {
            this.messageService.add({
              severity: 'error',
              detail: 'Email is required.',
            });
          } else if (
            this.emailValidations.get('emailId')?.hasError('email') ||
            this.emailValidations.get('emailId')?.hasError('pattern')
          ) {
            this.messageService.add({
              severity: 'error',
              
              detail: 'Please enter a valid email.',
            });
          }
          return;
        }
      }  
    }
  
    
    // Helper method to mark all controls in a form group as touched
    private markFormGroupTouched(formGroup: FormGroup) {
      Object.values(formGroup.controls).forEach((control) => {
        control.markAsTouched();
  
        if (control instanceof FormGroup) {
          this.markFormGroupTouched(control);
        }
      });
    }


  public getPlansDetails(){

    this.plansLoader = true;
    this.commonService.getAllNewPlans({type: [0,1,2,3,4,5,6]}).subscribe((res : any) => {
      const planDetails = res.message;
      let allPlans = [...planDetails[0], ...planDetails[5]];
      allPlans.pop();  // Removes the last element from the array
      this.subscriptionPlans = allPlans;      
      this.plansLoader = false;
    }, err=> {
      this.plansLoader = false;
    });
  }

  getAppNameByKey(key: string): string {
    const nameMap = {
      amy: 'Amy',
      amyCms: 'Amy CMS',
      connect: 'Amy Connect',
      enterpriseAi : 'Enterprise AI (Ask Amy)'
    };

    return nameMap[key] || '';
  }
  featuresToDisplay(plan) {
    return this.selectedPlanView === 0 ? plan.features : (plan.features_yearly ? plan.features_yearly : plan.features);
  }



  projectPlans = [
    {
      "title": "Basic",
      "description": "Perfect for small design projects",
      "price": "999",
      "features": [
        "2 design concepts",
        "1 revision round",
        "Technical drawings",
        "3D visualization"
      ],
      "button": "Get started"
    },
    {
      "title": "Most Popular",
      "description": "Ideal for medium-sized projects",
      "price": "2499",
      "features": [
        "5 design concepts",
        "3 revision rounds",
        "Technical drawings",
        "3D visualization",
        "Project management"
      ],
      "button": "Get started"
    },
    {
      "title": "Enterprise",
      "description": "Best for large-scale projects",
      "price": "4999",
      "features": [
        "Unlimited concepts",
        "Unlimited revisions",
        "Technical drawings",
        "3D visualization",
        "Project management",
        "Priority support"
      ],
      "button": "Get started"
    }
  ]
  
}
